/** 是否是女娲 */
export const isNuwarwe = ():boolean => location.host.indexOf('nuwarwe.net') > -1;

/** 是否是河肿BC */
export const isHenanBc = ():boolean => location.host.indexOf('henanbc') > -1;

/** 是否是东部战区总医院，东站心胸外科的拼音首字母 */
export const isDzxxwk = ():boolean => location.host.indexOf('dzxxwk') > -1;

/** 是否是 康弘 */
export const isKangeHong = ():boolean => location.host.indexOf('lmtvtdr') > -1;

/** 是否是 NF1 项目 */
export const isNf1 = ():boolean => location.host.indexOf('nf1') > -1;